import { SPLOOT_BADGE_COLOR } from "../themes";
import { EPenaltyActionStatus } from "../interfaces";


export const PENALTY_ACTION_STATUS_BADGE_COLORS = {
  [EPenaltyActionStatus.APPLIED]: SPLOOT_BADGE_COLOR.RED,
} as const;

export const VALID_PENALTY_ACTION_STATUSES = [
  EPenaltyActionStatus.APPLIED,
] as const;


